<script lang="ts">
import type { TimeStampType } from "@src/common/TimeStamp";
import EditorStore from "@src/model/Editor.Store";
import MainStore, { _FindInteractionPointAround } from "@src/model/Main.Store";
import type { InteractionPoint } from "@src/model/Main.Store";
import { afterUpdate, beforeUpdate, onDestroy, onMount } from "svelte";
import * as yaml from "js-yaml";


export let color: string = 'white';
export let object: InteractionPoint;

let left: number = 0;

function calculateLeft(around: TimeStampType) {
    let pxLeft = ((around || 0) * 100 / EditorStore.getSegmentLength());
    let timelineOffset = EditorStore.getValue().currentTimelineTrackDisplayOffset.getValue();
    // let maxX = (MainStore.getValue().currentVideoLength.getValue() || 0) / EditorStore.getSegmentLength() * 100 + timelineOffset;
    let resultX = timelineOffset + pxLeft;
    return resultX;
}

let doNotUpdateLeft: boolean = false;

let indicatorElem: HTMLSpanElement;
let subscribeList: any[] = [];
onMount(() => {
    subscribeList.push(
        EditorStore.getValue().currentTimelineSizingFactor.subscribe((v) => {
            // around = object.around;
            object = object;
            // let pxLeft = ((around || 0) * 100 / EditorStore.getSegmentLength());
            // let currentTrackDisplayOffset = EditorStore.getValue().currentTimelineTrackDisplayOffset.getValue();
            // left = currentTrackDisplayOffset + pxLeft;
            // indicatorElem.style.setProperty('left', `${currentTrackDisplayOffset + pxLeft}px`);
        }),
        EditorStore.getValue().currentTimelineTrackDisplayOffset.subscribe((v) => {
            // let pxLeft = ((around || 0) * 100 / EditorStore.getSegmentLength());
            // left = v + pxLeft;
            // around = object.around;
            object = object;
            // indicatorElem.style.setProperty('left', `${v + pxLeft}px`);
        }),
    );
    const mouseDownHandler = function(e) {
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
        document.body.style.cursor = 'col-resize';
        doNotUpdateLeft = true;
    };
    const mouseMoveHandler = function(e) {
        let timelineOffset = EditorStore.getValue().currentTimelineTrackDisplayOffset.getValue();
        let maxX = (MainStore.getValue().currentVideoLength.getValue() || 0) / EditorStore.getSegmentLength() * 100 + timelineOffset;
        let resultX = Math.min(maxX, Math.max(e.clientX, timelineOffset));
        left = resultX;
        // around = object.around;
        indicatorElem.style.setProperty('left', `${resultX}px`);
    };
    const mouseUpHandler = function() {
        indicatorElem.style.removeProperty('cursor');
        document.body.style.removeProperty('cursor');

        let timelineOffset = EditorStore.getValue().currentTimelineTrackDisplayOffset.getValue();
        let actualTime = (indicatorElem.getBoundingClientRect().x - timelineOffset) / 100 * EditorStore.getSegmentLength();
        // object.around = nSeg * 
        object.around = actualTime;
        object = object;
        let editor = EditorStore.getValue().currentCodeMirrorEditor;
        editor?.dispatch({
            changes: {
                from: 0,
                to: editor.state.doc.length,
                insert: yaml.dump(MainStore.dump(), { indent: 2 }),
            }
        });
        // Remove the handlers of `mousemove` and `mouseup`
        // around = object.around;
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
        doNotUpdateLeft = false;
    };
    indicatorElem.addEventListener('mousedown', mouseDownHandler);
});
onDestroy(() => {
    subscribeList.forEach((v) => v());
});
beforeUpdate(() => {
    console.log(`b`, object);
});
afterUpdate(() => {
    if (doNotUpdateLeft) { return; }
    left = calculateLeft(object.around);
});
</script>


<span class="interaction-indicator" style={`background-color:${color};border-left:1px ${color} solid;border-right:1px ${color} solid;left:${left}px`} bind:this={indicatorElem}>
</span>

<style>
    .interaction-indicator {
        display: 'inline-block';
        height: 16px;
        font-size: 0.8rem;
        user-select: none;
        position: fixed;
        width: 1px;
        margin-left: -2px;
    }
    .interaction-indicator:hover {
        cursor: move;
    }
</style>
